import React, { Component } from 'react';
import { Line } from '@vds/lines';
import vLogo from '../../assets/images/v-logo-alt.svg';
import {  Title,Micro, Subtitle, Body } from '@vds/typography';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import IdleTimer from 'react-idle-timer'
import { Row, Col } from '@vds/grids';
import { Button } from '@vds/buttons';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import InnerHTML from 'dangerously-set-html-content'
import {  ENABLE_AEM_CHANGES  } from './../../containers/constants';
import {getLqPageAds} from '../../Pages/AddressValidationPage/containers/action';

import { Input } from '@vds/inputs';
import {
	saveEmailAddress,
} from '../../containers/actions';
import { saveCartConfirmation } from "../../Pages/SaveCart/containers/actions";
import './Footer.css'
import { Notification } from '@vds/notifications';
import Icon from '@vds/icons';
import { MarginSpacerM, MarginSpacerL } from '../../Pages/Checkout/styleTag';


const RedirectModal = styled(Modal)`
height: auto;
@media only screen and (max-width: 600px) {
    position: absolute;
    top: 10px;
    right:10px;
    left:9px;
    width: 95vw;
    height: 97vh;
	max-width: 95vw;
    > div:first-child {
        padding:2px;
    }
}
> div:first-child {overflow:hidden}
`;

const ButtonWrapper = styled.div`
  display: flex;
  button {
    margin: 16px 16px 16px 0;
    width :176px;

  }
  padding-left: 50px;
  @media (min-width: 768px) {
    justify-content: flex-start;
  }
  @media (max-width: 768px) {
    button {
      justify-content: center;
      width: 100%;
    }
  }
`;

const IdleScreenModal = styled(Modal)`
height: 450px;
padding: 0px 0px 0px 40px;
width:737px;
// overflow: scroll;
.sco_info{
    line-height:1.4;
    width:80%;
}
.sco_sam-mail{
    color:#747676;
    margin-top:-10px !important;
}
h1{
  height: 32px;
  width: auto;
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 32px;
  margin-left:-1rem !important;
  margin-top:48px !important;
}
.clFtcO{
    font-size:15px;
    margin-bottom:20px;
    line-height:20px;
}
.form-field {
    height: 60px;
    width: 328px;
    margin-top:10px;
    margin-left:10px;
  }
  .font-sz-16{
      font-size:16px !important;
  }
  .sco_input{
      margin-top:5px !important;
  }
@media only screen and (max-width: 920px) {
    height:auto;
    h1{
        height: auto;
        line-height:24px;
        font-size:24px;
    }
    > div:first-child {
        padding:2px;
    }
}
// > div:first-child {overflow:hidden}
`;

const IdleButtonWrapper = styled.div`
  display: flex;
  button {
    margin: 16px 12px 0px 0px;
    width:203px;
    height:44px;
  }
  width:100%
  padding-left: 0px;
  margin-top:25px;
  @media (min-width: 768px) {

  }
  @media (max-width: 768px) {
      display:block !important;
      margin-top:32px;
    button {
      width:320px;
      height:44px;
      margin-top:12px;
    }
  }
`;

const InfoNotification = styled(Notification)`
.inFlex{
    display:flex;
}
.in-pt3{
    marginTop:'4px';
}
@media screen and (max-width:600px){
  resize_header_not{
		align-items: flex-start !important;
		flex-wrap: inherit !important;
	}
}
`;

const InfoMicro = styled(Micro)`
    padding-left:10px;
    color:#f6f6f6;
`;



class footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            openIdleModal: false,
            email:'',
            saveCartFlag:false,
            emailError:false
        }
        this.idleTimer = null
        this.handleOnIdle = this.handleOnIdle.bind(this)
        this.SaveCart=this.SaveCart.bind(this)   
     }
     
showModal = () => {
    // VBGVK-86 - removing redirection stopper modal
    // if(this.props.location.pathname =="/customize-order" ||this.props.location.pathname =="/checkout" ){
    // this.setState({
    //     openModal: true
    // })} else{
        window.location="https://www.verizon.com/business/small-medium/" ;
    // }
}
closeModal = (modal) => {
    this.setState({
        openModal: modal
    })
}
btnHandler = (value) => {
    this.setState({
        openModal: false
    })
    if(value == true){
        this.props.history.push('/save-cart')
    }
    else{
      window.location="https://www.verizon.com/business/small-medium/"  
    }
}
    

handleOnIdle (event) {
    console.log('user is idle', event)
    console.log('last active', this.idleTimer.getLastActiveTime())
     this.setState({openIdleModal:true});
    // window.confirm("Portal is Inactive")
   }
   closeIdleModal = (modal) => {
    if(document.getElementById("header-container")?.children[1]){
    document.getElementById("header-container").children[1].style.zIndex = 5
}
     this.setState({
         openIdleModal: modal
     })
     this.idleTimer.pause()
 }
 SaveCart(){
     const saveCartInfo = {
         Comments: "From Exit Modal",
         Disclaimer: 'N',
         EMail: this.state.email,
         RatingSelected: { _gbid: 1051 },
         SkipReminderMail: 'N'
       }
      // console.log(this.state.email)
       if(this.state.email!==undefined && this.state.email!==""){
         this.setState({emailError:false})
       const history = this.props.history;
       history.location.pathname="/foryoursmallbiz/internet/save-cart";
      // console.log("my historyy"+JSON.stringify(history))
       this.props.saveEmailAddress(this.state.email)
       this.props.saveCartConfirmation(saveCartInfo, history);
       this.props.history.push('/save-cart-confirmation')
       if(document.getElementById("header-container")?.children[1]){
       document.getElementById("header-container").children[1].style.zIndex = 5
       }
       this.setState({openIdleModal:false});
       }
       else{
         this.setState({emailError:true})
       }   
}
componentDidUpdate(){
    if(this.state.openIdleModal && document.getElementById("header-container")?.children[1]){
        document.getElementById("header-container").children[1].style.zIndex = 0

    }
}
    render() {
        let isHSIStatus = this.props.isHSIStatus === "Y";
        let isSpeedType = this.props.isSpeedType?.includes("VDSL");
        const mbgFlag = (isHSIStatus || isSpeedType);
        return (
        <footer onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
        }}>
              {/* {this.props.lqPageAds && this.props.location.pathname ==="/" && !this.props.hasPendingOrder  ?
                           <div style={{margin: 'auto', 'max-width': '85rem'}}>
                                <InnerHTML html={this.props.lqPageAds}/>
                            </div>
                            : <></>
                        } */}
            <div className="global-footer ec_interstitial">
                <div className="gf-wrap ec_links">
                    <div className="gf-footer">
                        <div className="gf-footer-bottom" role="contentinfo">
                            <div className="top">
                                <br />
                                <div className="gh-logo" id="logo">
                                    <a id="logo-url"  onClick={() => this.showModal()} >
                                        <img alt="Verizon logo" src={vLogo} />
                                    </a>
                                </div>
                                <div className="copyright_vz">
                                    <span>© Verizon 2022</span></div>
                                <div className="bbq">
                                    <a target="_blank" href="http://www.bbb.org/new-york-city/business-reviews/telephone-communications/verizon-communications-in-new-york-ny-411/#bbbonlineclick">
                                        <img alt="BBB logo" src="data:image/png;base64,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" id="BBQ" width="97"></img>
                                    </a>
                                </div>
                                <div className="fixer"> &nbsp;</div>
                                {/* <div className="ec-links">
                                    <a href="https://www.verizon.com/home/storelocator" >Store Locator</a>
                                    <a href="https://www.verizon.com/about/" >About Verizon</a>
                                    <a href="https://www.verizon.com/about/careers/">Careers</a>
                                    <a href="https://www.verizon.com/about/privacy/privacy-policy-summary" >Privacy</a>
                                    <a href="https://www.verizon.com/about/terms-conditions/overview" >Terms and Conditions</a>
                                    <a href="https://www.verizon.com/about/our-company/open-internet">Open Internet</a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <RedirectModal
                    ariaLabel=""
                    opened={this.state.openModal}
                    onOpenedChange={this.closeModal}>
                    <ModalTitle>
                        <Title size="small" primitive="h2">We will save your cart and send you an email with a link so you can continue where
                  you left off. Do you want to save the cart?</Title>
                    </ModalTitle>
                    <ModalBody>
                        <div>
                              <ButtonWrapper>
                                   <Button onClick={() => this.btnHandler()}  >No</Button>
							       <Button secondary width="100%" onClick={() => this.btnHandler(true)} >Save cart</Button>
                             </ButtonWrapper>
						
                        </div>
                    </ModalBody>
                </RedirectModal>
                {(this.props.location.pathname ==="/customize-order" ||
        this.props.location.pathname ==="/checkout") && 
        this.props.location.pathname !=="save-cart-confirmation" ?
            <> 
                    <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          timeout={5*60*1000}
          onIdle={this.handleOnIdle}
          debounce={250}
        />
                    <div className='sco-modal-con'>
                    <IdleScreenModal
                        ariaLabel=""
                        opened={this.state.openIdleModal}
                        onOpenedChange={this.closeIdleModal}
                        zIndex={99999999999999}
                        >
                        {!mbgFlag && <div style={{paddingTop:'60px', paddingRight:'35px', marginBottom:'-25px'}}>
                            <InfoNotification type="info">
                                <div className='inFlex'>
                                    <div>
                                        <Icon name='info' size="medium" inverted={true} medium/>
                                    </div>
                                    <div style={{paddingTop:'3px'}}>
                                        <span style={{marginLeft:'10px',lineHeight:'1',fontSize:'16px'}}>Money Back Guarantee</span>
                                    </div>
                                </div>
                                <div style={{fontWeight:'normal',paddingLeft:'30px',fontSize:'16px',paddingTop:'3px'}}>
                                    We offer a 30-day money-back guarantee. See details below.
                                </div>                            
                            </InfoNotification>
                        </div>}                       
                        <ModalTitle>
                            <Title size="small" primitive="h1" >
                                <span className="sco-modal">
                                Do you want to finish your purchase later?
                                </span>
                            </Title>
                        </ModalTitle>
                        <ModalBody style={{paddingLeft:'0px',marginRight:"20px"}}>
                                <Body size="medium" typescale="MVP" className="sub-content">
                                    <div className='sco_info'>
                                    Receive more information on our products and offers by confirming your email.
                                    We'll send a link to return to this cart, which will be accessible for ten days.
                                    </div>
                                </Body>
                            <Row>
                                <div className="form-field">
                                <Micro primitive="h2" >
                                    <span className="star">*</span> Email address
                                </Micro>
                                <Input
                                    type="text"
                                    placeholder=""
                                    required={true}
                                    error={this.state.emailError}
                                    errorText='Enter a valid email address'
                                    helperText='Ex: John@example.com'
                                    onChange={(e) => this.setState({email: e.target.value})}
                                    tooltipTitle='Enter the valid email address'
                                    tooltipContent="Example: John@example.com"
                                    className="sco_input"
                                /> 
                              </div>
                            </Row>
                            <IdleButtonWrapper>
                                <Button onClick={() => this.SaveCart()} className="font-sz-16">Confirm email</Button>
                                <Button secondary width="100%" 
                                onClick={() => this.closeIdleModal(false)} >Return to order</Button>
                            </IdleButtonWrapper>
                            <MarginSpacerL/>
                            {!mbgFlag && 
                                <Line type="xLight"/>}
                            {!mbgFlag && <MarginSpacerL/>}
                            {!mbgFlag && <Row>
                                <InfoMicro primitive="h2"><div style={{paddingLeft:'10px', color:'gray', fontSize:'12px'}}><strong>Money Back Guarantee</strong> (MBG) is available with 2 year contract 
                                only and requires cancellation within 30 days of installation;
                                excludes subscriptions, per minute usage, labor/material charges
                                in excess of standard installation and month-to-month service
                                plans, including Fios TV service. Wireless router available for
                                $299.99 purchase and $15/mo rental, subject to change. Phone
                                equipment purchase required with VoIP, starting at $85.
                                Equipment must be returned within 30 days of cancellation.
                                Equipment restocking fee may apply if order is cancelled or 
                                service is terminated within 30 days. MBG and/or promotional
                                offers do not apply to service ordered for temporary, short term 
                                or special events.</div></InfoMicro>
                                </Row>
                            }
                            <MarginSpacerM/>
                        </ModalBody>
                    </IdleScreenModal>
                    </div>
              </>:""}
        
            </div>
        </footer>
    );
    }
}
const mapStateToProps = (state) => {
    const { AddressValidationPage, CustomizeOrder } = state
    return {
    lqPageAds: AddressValidationPage.lqPageAds,
    hasPendingOrder: AddressValidationPage.hasPendingOrder,
    isHSIStatus: CustomizeOrder?.getPostLqData?.HSIStatus,
    isSpeedType: CustomizeOrder?.getPostLqData?.SpeedType,
    }
};
const mapDispatchToProps=(dispatch)=>({
    saveEmailAddress: (emailAddress) => {
		dispatch(saveEmailAddress(emailAddress))
	},
    saveCartConfirmation: (params) => {
		dispatch(saveCartConfirmation(params));
	},
})
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(footer))
